import theme from '../../base';

const storybook = {
  tableBg: theme.colors.neutrals.gray200,
  tableColorText: theme.colors.neutrals.gray900,
  tableColorTextReversed: theme.colors.neutrals.gray200,
  descriptionValueColor: theme.colors.neutrals.gray700,
  boxColor: theme.colors.blues.blue500,
  boxForegroundColor: theme.colors.neutrals.white,
  boxBorderColor: theme.colors.yellows.yellow400,
};

export default storybook;
